export const MONTH_NAMES = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
export const WEEK_LABELS = ["D", "S", "T", "Q", "Q", "S", "S"];
export const METHOD_LABELS = { boleto: "Boleto", pix: "PIX", cartao: "Cartão", dinheiro: "Dinheiro" };
export const METHOD_COLORS = { boleto: "#002FA7", pix: "#00A300", cartao: "#8B00FF", dinheiro: "#FFC000" };

export const emptyBill = { supplier_id: "", supplier_name: "", amount: "", due_date: "", payment_method: "boleto", description: "", category: "Geral", recurring: "none", recurring_end: "" };

export function iso(d) { return d.toISOString().slice(0, 10); }
